/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelUsersPowerbrokerTruckstop.ts     *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/powerbroker/users-powerbroker-truckstop";

export class AutogenModelUsersPowerbrokerTruckstop<RowType extends ModelRow> extends Endpoint<RowType, RowUsersPowerbrokerTruckstopFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowUsersPowerbrokerTruckstop extends ModelRow<RowUsersPowerbrokerTruckstopFields> {
	constructor(values?: Partial<RowUsersPowerbrokerTruckstopFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowUsersPowerbrokerTruckstopFields {
	bp_profile: string;
	company_id: string;
	dat_password: string;
	dat_user_id: string;
	default_dispatch_layout: string;
	loadboard_dat_id: string;
	loadboard_truckstop_rest_id: string;
	message_visibility: string;
	new_order_next_action: string;
	sms_message_limit: number;
	tm_profile: string;
	truckstop_access_token: string;
	truckstop_refresh_token: string;
	truckstop_token_expires: Date;
	truckstop_user_id: string;
	user_id: string;
}

